import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AppConfig } from 'src/app/config/routes.config';
import { AuthService } from 'src/app/core/auth/auth.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { Router, RouterLink } from "@angular/router";
import { UserDto } from "../../../app/api/models/user-dto";
import { UserProfileApiService } from 'src/app/api/services';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnums } from 'src/shared/models/enums';
import { IonHeader, IonToolbar, IonButtons, IonTitle, IonMenuButton } from "@ionic/angular/standalone";
import { LanguageSwitcherComponent } from "../elements/language-switcher/language-switcher.component";
import { NotificationsComponent } from "../elements/notifications/notifications.component";
import { IconComponent } from "../elements/icon/icon.component";
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({

    selector: 'vl-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [IonTitle, NgIf, IonHeader, IonMenuButton, TranslatePipe, RouterLink, IonButtons, IonToolbar, LanguageSwitcherComponent, NotificationsComponent, IconComponent],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() showMenuButton = true;
    @Input() showHomeButton = true;

    private notifier: Subject<any> = new Subject<any>();

    isPublicView;
    routes = AppConfig.routes;
    public userName: string;
    public isUserVerified = false;
    @Input() user: UserDto;


    constructor(private authService: AuthService,
                private router: Router,
                private storage: StorageService,
                private profileUserService: UserProfileApiService,
                private eventsService: EventsService) {
        this.authService.$userAuth
            .pipe(
                takeUntil(this.notifier)
            ).subscribe(b => {
            this.isPublicView = !b;
            if(this.isPublicView) {
                this.userName = '';
            }
        });
        this.eventsService.$profileObs.pipe(takeUntil(this.notifier)).subscribe(r => {
            this.user = r;
            this.userName = r?.firstName || r?.lastName ? `${r?.firstName} ${r?.lastName}` : `${r?.email}`;
            this.isUserVerified = this.isUserVerifyAndAccepted(r);
        });
    }
    
    async ngOnInit() {
       const storageUser = await this.storage.getItem(StorageEnums.USER_ID);
        if(storageUser) {
            this.user = storageUser;
            this.userName = storageUser ? `${storageUser?.firstName} ${storageUser?.lastName}` : '';
            this.isUserVerified = this.isUserVerifyAndAccepted(storageUser);
        }
    }

    ngOnDestroy(): void {
        this.notifier.next('');
        this.notifier.complete();
    }

    ionViewWillLeave() {
        this.notifier.next('');
        this.notifier.complete();
    }

    redirectToSettings() {
        this.router.navigate([this.routes.settings.fullPath]);
    }

    isUserVerifyAndAccepted(user: UserDto): boolean{
        return user?.phoneVerified && user?.emailVerified && !!user?.account?.agreedWithPrivacy && !!user?.account?.agreedWithTerms;
    }
}
